export const setStrategies = (
  strategyTemplateId: string,
  disallowedStrategies: string[],
  isChecked: boolean
): string[] => {
  const newDisallowedStrategies = disallowedStrategies || []

  if (isChecked) {
    const index = newDisallowedStrategies.findIndex(x => x === strategyTemplateId)
    if (index === -1) {
      return newDisallowedStrategies
    }

    newDisallowedStrategies.splice(index, 1)
  } else if (!newDisallowedStrategies.includes(strategyTemplateId)) {
    newDisallowedStrategies.push(strategyTemplateId)
  }

  return newDisallowedStrategies
}

export const getIsChecked = (strategyTemplateId: string, disallowedStrategies?: string[]) => {
  if (!Array.isArray(disallowedStrategies)) {
    return false
  }

  return !disallowedStrategies.includes(strategyTemplateId)
}

export const getIsDisabled = (strategyTemplateId: string, disallowedStrategies?: string[]) =>
  !getIsChecked(strategyTemplateId, disallowedStrategies)
